import { ViewportType } from '../../../enums';
export const VIDEO_PROJECTION_ID = 'video';
